export const GET_VENDOR_USER_LIST_REQUEST = "GET_VENDOR_USER_LIST_REQUEST"
export const GET_VENDOR_USER_LIST_SUCCESS = "GET_VENDOR_USER_LIST_SUCCESS"
export const ADD_VENDOR_USER_REQUEST = "ADD_VENDOR_USER_REQUEST"
export const ADD_VENDOR_USER_SUCCESS = "ADD_VENDOR_USER_SUCCESS"
export const ACTIVE_INACTIVE_VENDOR_USER_REQUEST = "ACTIVE_INACTIVE_VENDOR_USER_REQUEST"
export const ACTIVE_INACTIVE_VENDOR_USER_SUCCESS = "ACTIVE_INACTIVE_VENDOR_USER_SUCCESS"
export const RESEND_VENDOR_USER_EMAIL_REQUEST = "RESEND_VENDOR_USER_EMAIL_REQUEST"
export const RESEND_VENDOR_USER_EMAIL_SUCCESS = "RESEND_VENDOR_USER_EMAIL_SUCCESS"
export const CLEAR_VENDOR_USER_REQ = "CLEAR_VENDOR_USER_REQ"
export const GET_UNASSIGNED_VENDOR_USER_LIST_REQUEST = "GET_UNASSIGNED_VENDOR_USER_LIST_REQUEST"
export const GET_UNASSIGNED_VENDOR_USER_LIST_SUCCESS = "GET_UNASSIGNED_VENDOR_USER_LIST_SUCCESS"
export const ASSIGN_VENDOR_USER_REQUEST = "ASSIGN_VENDOR_USER_REQUEST"
export const ASSIGN_VENDOR_USER_SUCCESS = "ASSIGN_VENDOR_USER_SUCCESS"
